import { combineReducers } from 'redux'
import auth from '../redux/auth'
import error from '../redux/error'
import device from '../redux/device'
import event from '../redux/event'
import summary from '../redux/summary'
import projects from '../redux/projects'
import deals from '../redux/deals'
import exco from '../redux/exco'
import businesses from '../redux/businesses'
import financials from '../redux/financials'
import treasury from '../redux/treasury'
import opex from '../redux/opex'
import team from '../redux/team'
import game from '../redux/game'
import ui from '../redux/ui'
import peerInsights from '../redux/peer-insights'
import files from '../redux/files'
import survey from '../redux/survey'
import help from '../redux/help'
import resources from '../redux/resources'
import content from '../redux/content'
import participants from '../redux/participants'

const createRootReducer = () => {
  const appReducer = combineReducers({
    auth,
    error,
    device,
    event,
    resources,
    summary,
    businesses,
    financials,
    treasury,
    opex,
    team,
    game,
    projects,
    deals,
    exco,
    ui,
    peerInsights,
    files,
    survey,
    help,
    content,
    participants
  })

  return appReducer
}

export default createRootReducer
